import { BookingTypeIcon } from 'common-components/tags';
import moment from 'moment';
import React from 'react';
import { BookingType, ShiftSlotStatus } from 'utilities/enum-utils';
import { Broadcast } from '@good/icons';
import { IRosterShift } from '../types';
import { Badge, Group, Text } from '@good/ui/core';
import { useBookings } from 'views/bookings-v2/books-view-context/bookings-view-context';
import { ROSTER_TAB } from '../components/roster-common-enums';
import { RosterCard } from './roster-card';
import { CardTime } from './card-time';

interface OpenSlotCardProps {
  shift: IRosterShift;
  tab: ROSTER_TAB;
  rowIndex?: number;
}

export function OpenSlotCard({ shift, tab, rowIndex }: OpenSlotCardProps) {
  const { shiftStartDateTime, shiftEndDateTime, serviceName, duplicateCount } = shift;
  const mStartDate = moment(shiftStartDateTime);
  const mEndDate = moment(shiftEndDateTime);
  const startTimeDisplay = mStartDate.format('h:mm a');
  const endTimeDisplay = mEndDate.format('h:mm a');
  const onSelectRosterItem = useBookings((selector) => selector.onSelectRosterItem);
  const selectedRosterItem = useBookings((selector) => selector.selectedRosterItem);
  const isSelected = Boolean(
    selectedRosterItem &&
      ((shift.bookingId && selectedRosterItem?.bookingId === shift.bookingId) ||
        ('supportWorkerAttendanceId' in selectedRosterItem &&
          shift.supportWorkerAttendanceId &&
          selectedRosterItem?.supportWorkerAttendanceId === shift.supportWorkerAttendanceId)),
  );

  return (
    <RosterCard
      bg='yellow.0'
      borderColor='var(--mantine-color-yellow-5)'
      endDateTime={shift.shiftEndDateTime}
      startDateTime={shift.shiftStartDateTime}
      onSelect={() => onSelectRosterItem({ item: shift, type: 'openSlot', tab })}
      rowIndex={rowIndex}
      selected={isSelected}
      tab={tab}
      className='border-dashed'
      topSection={
        <Group wrap='nowrap' gap={8} align='center'>
          {(duplicateCount ?? 0) > 1 && (
            <Badge color='orange' variant='outline' tt='lowercase' size='sm'>
              {duplicateCount}x
            </Badge>
          )}
          {shift.shiftSlotStatus === ShiftSlotStatus.PUBLISHING ||
          shift.shiftSlotStatus === ShiftSlotStatus.PUBLISHED ? (
            <Badge size='sm' variant='outline' color='pink' leftSection={<Broadcast />}>
              Published
            </Badge>
          ) : (
            <Badge size='sm' variant='outline' color='orange'>
              Open slot
            </Badge>
          )}
        </Group>
      }
    >
      <div className='whitespace-nowrap text-overflow-ellipsis'>
        <CardTime startTime={startTimeDisplay} endTime={endTimeDisplay} />
        <Group wrap='nowrap' gap={4} align='center'>
          <BookingTypeIcon
            size='xs'
            type={shift.bookingType === BookingType.ACTIVITY_RECORD ? BookingType.ACTIVITY_RECORD : shift.serviceType}
          />
          <Text size='sm'>{serviceName}</Text>
        </Group>
      </div>
    </RosterCard>
  );
}
